import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Step marker shared by the Setup guide page and the ChatWelcome hero
 * (RFC-231). One primitive so the two renderers can't drift visually.
 */
export function GuideStepDot({
  done,
  current = false,
  running = false,
  className,
}: {
  done: boolean
  current?: boolean
  running?: boolean
  className?: string
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'mt-0.5 inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border bg-card text-[10px]',
        done
          ? 'border-status-green bg-status-green-bg text-status-green'
          : running
            ? 'animate-pulse border-primary text-primary'
            : current
              ? 'border-foreground ring-[3px] ring-muted'
              : 'border-border',
        className,
      )}
    >
      {done ? <Check className='h-3 w-3' strokeWidth={3} /> : running ? '·' : null}
    </span>
  )
}
